import { render, staticRenderFns } from "./MdmSuperDownRecord.vue?vue&type=template&id=5be1413f&"
import script from "./MdmSuperDownRecord.vue?vue&type=script&lang=js&"
export * from "./MdmSuperDownRecord.vue?vue&type=script&lang=js&"
import style0 from "./MdmSuperDownRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports